// FULL POPUP STUFF

function checkScrollbar() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function bodyStopScroll() {
  const scrollWidth = checkScrollbar();
  const stopScrollStyle = `
      <style id="scrollStuff">
        html {overflow: hidden;}
        body, .js_noscrol_padding { padding-right: ${scrollWidth}px; }
        .js_noscrol_margin { margin-right: ${scrollWidth}px; }
        body { width:auto; }
      </style>
    `;
  if (!document.querySelector('#scrollStuff')) {
    document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
  }
  document.body.classList.add('noscroll');
}
function bodyRemoveStopScroll() {

  document.head.querySelectorAll('#scrollStuff').forEach(item => {
    item.remove();
  });

  document.body.classList.remove('noscroll');
}
// ==============





// ==========================


// let's get this party started
document.addEventListener('DOMContentLoaded', function () {




  // FILTER


  (function () {
    var tags = document.querySelector('.js_tags');
    if (!tags) return;

    var buttons = Array.prototype.slice.call(tags.querySelectorAll('.tags__tag[data-target]'));
    if (!buttons.length) return;

    var sectionIds = [];
    buttons.forEach(function (btn) {
      var target = btn.getAttribute('data-target') || '';
      if (target === 'all') return;
      target.split(',').forEach(function (id) {
        id = id.trim();
        if (id && sectionIds.indexOf(id) === -1) {
          sectionIds.push(id);
        }
      });
    });

    var sections = sectionIds
      .map(function (id) { return document.getElementById(id); })
      .filter(Boolean);

    function setActiveButton(activeBtn) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('m-current', btn === activeBtn);
      });
    }

    function filterSections(target) {
      var showAll = target === 'all';
      var visibleIds = showAll
        ? null
        : target.split(',').map(function (id) { return id.trim(); }).filter(Boolean);

      sections.forEach(function (section) {
        var isVisible = showAll || visibleIds.indexOf(section.id) !== -1;
        section.classList.toggle('m-hidden', !isVisible);
      });
    }

    tags.addEventListener('click', function (event) {
      var btn = event.target.closest('.tags__tag[data-target]');
      if (!btn || !tags.contains(btn)) return;

      var target = btn.getAttribute('data-target') || '';
      setActiveButton(btn);
      filterSections(target);
      tags.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();


  // ==========================






  // VIDEO PAUSE/PLAY ON SCROLL
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        target.setAttribute('autoplay', 'autoplay');
        target.play().catch(() => { });
        // console.log('play');
      } else {
        target.pause();
        // console.log('pause');
      }
    });
  }, {
    root: null,
    rootMargin: '200px 0px',
    threshold: 0
  });

  document.querySelectorAll('video[muted]').forEach(video => observer.observe(video));





  // PRODMAP POPUP STUFF

  document.querySelectorAll('.js_pmap_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const triggerParent = trigger.closest('.js_pmap_item');
      if (triggerParent) {
        triggerParent.classList.add('m-active');
      }
      const triggerContent = triggerParent.querySelector('.js_pmap_popcontent').innerHTML;

      const popupTarget = document.querySelector('#pmap-popup');
      if (popupTarget && triggerContent) {

        popupTarget.querySelector('.js_pmap_popup_content').innerHTML = triggerContent;

        popupTarget.classList.add('m-active');
      }
    });
  });


  function closePmapPopup() {
    const popupTarget = document.querySelector('#pmap-popup.m-active');
    if (popupTarget) {
      popupTarget.classList.remove('m-active');
      document.querySelectorAll('.js_pmap_item.m-active').forEach(item => {
        item.classList.remove('m-active');
      });
      setTimeout(() => {
        popupTarget.querySelector('.js_pmap_popup_content').innerHTML = '';
      }, 300);
    }
  }

  document.querySelectorAll('.js_pmap_popup_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      closePmapPopup();
    });
  });



  // ========================

  // ACTIVE TOGGLE
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold) {
        toggleHold = true;
        let toggleTarget = '';
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }

        if (toggleTarget) {
          if (toggleTarget.classList.contains('js_toggle')) {
            toggleTarget.querySelectorAll('.js_toggle_trigger').forEach(item => {
              item.classList.toggle('m-active');
            });
          }
          else {
            trigger.classList.toggle('m-active');
          }
          toggleTarget.classList.toggle('m-active');
        }
        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });
  // ========================


  // FULL POPUP STUFF

  document.querySelectorAll('.js_popup_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const popupTarget = trigger.getAttribute('href')
        ? document.querySelector(trigger.getAttribute('href'))
        : document.querySelector(trigger.getAttribute('data-target'));

      if (popupTarget) {

        bodyStopScroll();
        popupTarget.classList.add('m-active');

        trigger.classList.add('focusHolder');

        setTimeout(() => {
          popupTarget.setAttribute('tabindex', '-1');
          popupTarget.focus();
          popupTarget.blur();
          popupTarget.removeAttribute('tabindex');
        }, 500);
      }
    });
  });


  document.querySelectorAll('.js_popup_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  });


  let isEsc = false;
  document.addEventListener('keyup', function (event) {
    if (event.key === "Escape") {
      isEsc = true;
      closePopup();
      closePmapPopup();
    }
  });

  function closePopup() {
    const activePopup = document.querySelector('.js_popup.m-active');
    if (activePopup) {
      activePopup.classList.remove('m-active');
      setTimeout(() => {
        bodyRemoveStopScroll();

        const focusTarget = document.querySelector('.focusHolder');
        // if (focusTarget) {
        //   focusTarget.focus();
        //   if (!isEsc) {
        //     focusTarget.blur();
        //   }
        //   focusTarget.classList.remove('focusHolder');
        // }

        if (focusTarget) {
          if (focusTarget.closest('.swiper')) {
            focusTarget.closest('.swiper').setAttribute('tabindex', '-1');
            focusTarget.closest('.swiper').focus();
            focusTarget.closest('.swiper').blur();
          }
          else {
            focusTarget.focus();
            if (!isEsc) {
              focusTarget.blur();
            }
          }
          focusTarget.classList.remove('focusHolder');
        }

        isEsc = false;
      }, 300);
    }
    else {
      isEsc = false;
    }
  }


  // ==========================


  let stopscrollHold = false;
  document.querySelectorAll('.js_stopscroll').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!stopscrollHold) {
        stopscrollHold = true;
        if (!document.body.classList.contains('noscroll')) {
          bodyStopScroll();
        } else {
          setTimeout(() => {
            bodyRemoveStopScroll();
          }, 500);
        }
        setTimeout(() => {
          stopscrollHold = false;
        }, 500);
      }
    });
  });


  // ON HORIZONTAL RESIZE
  // - remove bodystopscroll
  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {

        if (document.head.querySelector('#scrollStuff')) {
          bodyRemoveStopScroll();
        }

      }, 150)
    }
  }, false)




});


// =================================================
// =================================================
// =================================================

